import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import React from "react"
import {
  black,
  ChooseColorsWrapper,
  ColorInput,
  ColorRow,
  InputLabel,
  offBlack,
  StyleItem,
  white
} from "./ui"
import { clearCustomColors } from "./utils"

const getDefaultColorState = (props) => {
  return {
    color: props.color || black,
    backgroundColor: props.backgroundColor || white
  }
}

const CustomColors = (props) => {
  const { onSubmitColors, onClearCustomColors, onGoBack, hasCustomColors } =
    props

  const defaultState = getDefaultColorState(props)

  const [color, setColor] = React.useState(defaultState.color)
  const [backgroundColor, setBackgroundColor] = React.useState(
    defaultState.backgroundColor
  )
  const [clearingCustom, setClearingCustom] = React.useState(false)

  const handleChangeColor = (colorType) => (value) => {
    if (colorType === "color") {
      setColor(value)
    } else {
      setBackgroundColor(value)
    }
  }

  // Apply custom colors (and close color picker)
  const handleSubmitColors = () => onSubmitColors({ color, backgroundColor })

  const handleToggleClear = (toggle) => () => setClearingCustom(toggle)

  // Remove custom colors in local storage and close custom colors panel
  const handleClearCustom = () => {
    setClearingCustom(false)
    clearCustomColors()
    onClearCustomColors()
  }

  const colorSquareStyles = {
    width: "40px",
    height: "30px",
    marginLeft: "5px",
    borderRadius: "7px",
    padding: "5px 10px"
  }

  return (
    <ChooseColorsWrapper>
      <Button
        onClick={onGoBack}
        styleType="text"
        style={{ borderBottom: "none" }}
        color={offBlack}
      >
        <Pathicon icon="arrow-left" style={{ marginRight: "0.5rem" }} />
        Back
      </Button>
      <StyleItem
        style={{
          margin: "1rem 0",
          padding: "0",
          height: "100px",
          border: "solid 1px #efefef",
          color,
          backgroundColor,
          cursor: "auto",
          borderRadius: "7px"
        }}
      >
        This is a preview
      </StyleItem>
      <InputLabel>Text Color</InputLabel>
      <ColorRow>
        <ColorInput
          type="text"
          onChange={handleChangeColor("color")}
          placeholder="Add a text color"
          value={color}
        />
        <StyleItem
          className="BlocksStyles__StyleItem"
          selected={color === white || color === "#fff" || color === "white"}
          applyHoverShadows={true}
          style={{
            ...colorSquareStyles,
            backgroundColor: white,
            border: "1px solid lightgray",
            boxShadow:
              color === white || color === "#fff" || color === "white"
                ? "inset 0 0 0 2px white, 0 0 0 2px rgba(100,100,100)"
                : ""
          }}
          onClick={() => handleChangeColor("color")(white)}
        />
        <StyleItem
          className="BlocksStyles__StyleItem"
          selected={color === black || color === "#000" || color === "black"}
          applyHoverShadows={true}
          style={{
            ...colorSquareStyles,
            backgroundColor: black,
            boxShadow:
              color === black || color === "#000" || color === "black"
                ? "inset 0 0 0 2px white, 0 0 0 2px rgba(100,100,100)"
                : ""
          }}
          onClick={() => handleChangeColor("color")(black)}
        />
      </ColorRow>
      <InputLabel>Background Color</InputLabel>
      <ColorRow>
        <ColorInput
          type="text"
          onChange={handleChangeColor("backgroundColor")}
          placeholder="Add a background color"
          value={backgroundColor}
        />
        <StyleItem
          className="BlocksStyles__StyleItem"
          selected={
            backgroundColor === white ||
            backgroundColor === "#fff" ||
            backgroundColor === "white"
          }
          applyHoverShadows={true}
          style={{
            ...colorSquareStyles,
            backgroundColor: white,
            border: "1px solid lightgray",
            boxShadow:
              backgroundColor === white ||
              backgroundColor === "#fff" ||
              backgroundColor === "white"
                ? "inset 0 0 0 2px white, 0 0 0 2px rgba(100,100,100)"
                : ""
          }}
          onClick={() => handleChangeColor("backgroundColor")(white)}
        />
        <StyleItem
          className="BlocksStyles__StyleItem"
          selected={
            backgroundColor === black ||
            backgroundColor === "#000" ||
            backgroundColor === "black"
          }
          applyHoverShadows={true}
          style={{
            ...colorSquareStyles,
            backgroundColor: black,
            boxShadow:
              backgroundColor === black ||
              backgroundColor === "#000" ||
              backgroundColor === "black"
                ? "inset 0 0 0 2px white, 0 0 0 2px rgba(100,100,100)"
                : ""
          }}
          onClick={() => handleChangeColor("backgroundColor")(black)}
        />
      </ColorRow>
      {clearingCustom ? (
        <ColorRow>
          Are you sure?
          <div>
            <Button
              style={{ marginRight: "5px" }}
              color={offBlack}
              onClick={handleClearCustom}
            >
              Yes
            </Button>
            <Button
              color={offBlack}
              styleType="text"
              onClick={handleToggleClear(false)}
            >
              Cancel
            </Button>
          </div>
        </ColorRow>
      ) : (
        <ColorRow>
          <Button
            style={{ marginRight: "5px" }}
            color={offBlack}
            onClick={handleSubmitColors}
          >
            Apply Changes
          </Button>
          {hasCustomColors && (
            <Button
              color={offBlack}
              styleType="text"
              onClick={handleToggleClear(true)}
            >
              Clear Colors
            </Button>
          )}
        </ColorRow>
      )}
    </ChooseColorsWrapper>
  )
}

export default CustomColors
